import { Filters, } from "@domains/aggregates/interfaces/Reports/iReportsCommon";
import Checkbox from "@frameworks/web/components/generic/CheckBoxGeneric";
import { BtnDNAproperties, EBtnDNAproperties, } from "@frameworks/web/components/Reports/RebrandedReports/constant";
import TwinBtns from "@frameworks/web/components/Reports/RebrandedReports/GenericComponents/TwinBtns";
import React, { useEffect, useState } from "react";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
const TxnFilters = (props) => {
    const device = DeviceContext();
    const [activeSection, setActiveSection] = useState(props.activeFilterSubSection);
    const [areFiltersEqual, setAreFiltersEqual] = useState(false);
    const [tempTxnFilters, setTempTxnFilters] = useState(new Map());
    const getSelectedFilterCount = (filters) => {
        let count = 0;
        filters.forEach((filter) => {
            if (filter === null || filter === void 0 ? void 0 : filter.selected)
                count++;
        });
        return count;
    };
    const checkAllSelected = () => {
        if (!tempTxnFilters.has(activeSection))
            return false;
        let filterList = tempTxnFilters.get(activeSection).filters;
        let count = getSelectedFilterCount(filterList);
        return count === (filterList === null || filterList === void 0 ? void 0 : filterList.length);
    };
    const onChange = (filterKey, checked) => {
        const sectionFilter = tempTxnFilters.get(activeSection);
        if (!sectionFilter)
            return;
        const updatedFilters = sectionFilter.filters.map((filter) => filter.key === filterKey ? Object.assign(Object.assign({}, filter), { selected: checked }) : filter);
        const newFilter = new Filters(sectionFilter.name, updatedFilters, sectionFilter.title);
        const newMap = new Map(tempTxnFilters);
        newMap.set(activeSection, newFilter);
        setTempTxnFilters(newMap);
    };
    const selectAll = (checked, activeSection) => {
        let sectionfilter = tempTxnFilters.get(activeSection);
        let updatedFilters = sectionfilter.filters.map((filter) => (Object.assign(Object.assign({}, filter), { selected: checked })));
        let newFilter = new Filters(sectionfilter === null || sectionfilter === void 0 ? void 0 : sectionfilter.name, updatedFilters, sectionfilter === null || sectionfilter === void 0 ? void 0 : sectionfilter.title);
        let newMap = new Map(tempTxnFilters);
        newMap.set(activeSection, newFilter);
        setTempTxnFilters(newMap);
    };
    const checkAreFiltersEqual = () => {
        //if already applied filters are equal to temporary selected filter then disable apply filter btn
        //only check selected condition.
        if (!(props === null || props === void 0 ? void 0 : props.txnFilters))
            return true;
        for (let [key, filterGroup] of props.txnFilters.entries()) {
            const tempFilterList = tempTxnFilters.get(key);
            if (!tempFilterList)
                return false;
            for (let i = 0; i < filterGroup.filters.length; i++) {
                if (filterGroup.filters[i].selected !== tempFilterList.filters[i].selected) {
                    return false;
                }
            }
        }
        return true;
    };
    useEffect(() => {
        setTempTxnFilters(props === null || props === void 0 ? void 0 : props.txnFilters);
    }, [props === null || props === void 0 ? void 0 : props.txnFilters]);
    useEffect(() => {
        setAreFiltersEqual(checkAreFiltersEqual());
    }, [tempTxnFilters]);
    const getActiveSectionFilterlist = (addSelectAll, fontSize) => {
        var _a, _b, _c;
        return (React.createElement("div", { className: "active-section-filterlist" },
            addSelectAll && (React.createElement("div", { className: "filter-option" },
                React.createElement(Checkbox, { className: "common-checkbox-custom small-checkbox alignment-content list-container DMSanN_14_400", list: { display: "All", value: activeSection }, name: "All", key: activeSection, selected: checkAllSelected() ? activeSection : "", onChange: (e) => {
                        selectAll(e.target.checked, activeSection);
                    }, moduleName: `list-item` }))), (_c = (_b = (_a = tempTxnFilters === null || tempTxnFilters === void 0 ? void 0 : tempTxnFilters.get(activeSection)) === null || _a === void 0 ? void 0 : _a.filters) === null || _b === void 0 ? void 0 : _b.map) === null || _c === void 0 ? void 0 :
            _c.call(_b, (item, id) => {
                return (React.createElement("div", { className: "filter-option" },
                    React.createElement(Checkbox, { className: `common-checkbox-custom small-checkbox alignment-content list-container ${fontSize} `, list: { display: item.title, value: item.key }, name: item.title, key: item.key, selected: item.selected ? item.key : "", onChange: (event) => {
                            onChange(event.target.value, event.target.checked);
                        }, moduleName: `list-item` })));
            })));
    };
    if (device === null || device === void 0 ? void 0 : device.isDesktop)
        return (React.createElement("div", { className: "txn-filter-container " },
            Array.from(tempTxnFilters.entries()).map(([sectionKey, filterObj]) => (React.createElement("div", { className: "filter-section" },
                React.createElement("div", { className: "section-heading DMSan_16_700 txt_blackOne1", onClick: () => {
                        setActiveSection(sectionKey);
                    } },
                    React.createElement("span", { className: "section-title" }, filterObj === null || filterObj === void 0 ? void 0 :
                        filterObj.title,
                        "\u00A0(",
                        getSelectedFilterCount(filterObj.filters),
                        ")"),
                    React.createElement("span", { className: `accordian-arrows ${activeSection === sectionKey ? "  " : " down"} ` },
                        React.createElement("i", { className: "edel-icon-arrow-up flexCenter" }))),
                activeSection === sectionKey &&
                    getActiveSectionFilterlist(false, "DMSanM_14_500")))),
            React.createElement("div", { className: "filter-apply-cancel-btns " },
                React.createElement(TwinBtns, { parentClass: "buy-sell-btns buy-sell-btns-spacing ", leftBtn: Object.assign(Object.assign({}, BtnDNAproperties[EBtnDNAproperties.CANCEL]), { value: "Reset", onClick: () => props === null || props === void 0 ? void 0 : props.resetFilter() }), rightBtn: Object.assign(Object.assign({}, BtnDNAproperties[EBtnDNAproperties.APPLY]), { disabled: areFiltersEqual, onClick: () => {
                            props === null || props === void 0 ? void 0 : props.applyFilter(tempTxnFilters, activeSection);
                        } }) }))));
    return (React.createElement("div", { className: "txn-filter-container" },
        React.createElement("div", { className: "txn-filter-section" },
            React.createElement("div", { className: "filter-section-list" }, Array.from(tempTxnFilters.entries()).map(([sectionKey, filterObj]) => (React.createElement("div", { className: `filter-section ${activeSection === sectionKey ? "active-section" : ""}`, onClick: () => {
                    setActiveSection(sectionKey);
                } },
                React.createElement("span", { className: "section-title" }, filterObj === null || filterObj === void 0 ? void 0 :
                    filterObj.title,
                    "\u00A0(",
                    getSelectedFilterCount(filterObj.filters),
                    ")"))))),
            getActiveSectionFilterlist(true, "DMSanN_14_400")),
        React.createElement("div", { className: "filter-apply-cancel-btns" },
            React.createElement(TwinBtns, { parentClass: "buy-sell-btns buy-sell-btns-spacing ", leftBtn: Object.assign(Object.assign({}, BtnDNAproperties[EBtnDNAproperties.CANCEL]), { onClick: () => props === null || props === void 0 ? void 0 : props.setOpenDrawer(false) }), rightBtn: Object.assign(Object.assign({}, BtnDNAproperties[EBtnDNAproperties.APPLY]), { disabled: areFiltersEqual, onClick: () => {
                        props === null || props === void 0 ? void 0 : props.applyFilter(tempTxnFilters, activeSection);
                    } }) }))));
};
export default TxnFilters;
